import { Box, Center, Spinner } from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { RoutePermissionFunction } from "router-manager/parts";
import { useApplicationContext } from "contexts/ApplicationContext";

export default function VendeAIPage() {
  const { user } = useApplicationContext();
  const codigoNova = user.userData.customerCodigoNova;
  const protocol = process.env.NODE_ENV === "development" ? "http" : "https";
  const url = `${protocol}://app.vendeaitecnologia.com.br/indicacao/entrar?external_id=${codigoNova}&indication_partner=nova`;

  return (
    <GetLayout pageContentProps={{ p: 0 }}>
      {codigoNova ? (
        <Box
          as="iframe"
          src={url}
          title="Painel de Relatórios do Looker Studio"
          width="100%"
          height="calc(100vh - 80px)"
          border="0"
          allowFullScreen
        />
      ) : (
        <Center w="100%" h="100%">
          <Spinner />
        </Center>
      )}
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) => {
    return (
      (!user?.userData.parentCustomerId && ["SUPER", "PARCEIRO_MASTER"].includes(user?.userData.type || ""))
      ||
      [1,2,7215,11031, // usuarios dev e dudu
       15198,12841,26171,27446,17710,23405,19305,19433,19628,29855,15419,29980,18202,11730,21028,12397,
       12402,26881,11729,18971,13076,25,29,23031,12434,28454,29875,26743,26741,24473,18093,12401,2517,
       26625,21026,30557,30,12396,25994,12387,28309,17699,13075,28998,12394,6714,23512,12400,28673,12390,
       14,5666,20242,31,12386,14135,12432,26924,12398,13,13070].includes(user?.userData?.userId || -1)
    );
  });
};
